import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.0.7_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/.pnpm/sonner@2.0.7_react-dom@18.3.1_react@18.3.1/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorHandler"] */ "/vercel/path0/src/components/error-handler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MasqueradeBanner"] */ "/vercel/path0/src/components/masquerade-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferralWrapper"] */ "/vercel/path0/src/components/referral-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpicenetFooter"] */ "/vercel/path0/src/components/SpicenetFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpicenetNavigation"] */ "/vercel/path0/src/components/SpicenetNavigation.tsx");
